import React, { useState, useEffect } from "react";
import "../../src/styles/assets/sizes.css";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { getData } from "../services/api.service";
import BackButton from "../components/common/BackButton";
import Image from "../assets/img/Logo2.png";
import { useDispatch } from "react-redux";
import { addBurger, editBurger } from "../redux/reducers/cartActions";
import { swalAlertInfo } from "../components/common/Alerts";

const OrderChooseToppings = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { type_id, size_id, branch_id } = useParams(); // ID del tipo de hamburguesa, tamaño y sucursal

  // Estado de carga
  const [isLoading, setIsLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(null);

  const [cheeses, setCheeses] = useState([]); // Quesos disponibles para la hamburguesa
  const [toppings, setToppings] = useState([]); // Toppings disponibles para la hamburguesa
  const [selectedCheeses, setSelectedCheeses] = useState([]); // Quesos seleccionados por el usuario
  const [selectedToppings, setSelectedToppings] = useState([]); // Toppings seleccionados por el usuario
  const sizeShortDesc = location.state?.size_short_desc || ""; // Descripción corta del tamaño de la hamburguesa
  const base_price = location.state?.base_price || 0; // Precio base de la hamburguesa
  const extra_cheese_price = location.state?.extra_cheese_price || 0; // Precio del extra de queso

  // Estados para edición
  const isEditing = location.state?.isEditing || false;
  const editIndex = location.state?.editIndex;
  const editData = location.state?.editData || {};

  const [extraCheese, setExtraCheese] = useState(editData.extraCheese || false); // Estado para extra queso
  const [selectedFriesAddons, setSelectedFriesAddons] = useState(
    editData.selectedFriesAddons || []
  ); // Lista de addons de papas fritas seleccionados
  const [flagFries, setFlagFries] = useState(0); // Indica si las papas fritas están disponibles (1) o no (0)
  const [fries, setFries] = useState([]); // Lista de papas fritas disponibles
  const [quantity, setQuantity] = useState(editData.quantity || 1); // Cantidad de hamburguesas a agregar
  const [observation, setObservations] = useState(editData.observation || ""); // Observaciones del pedido

  const [burgerVarieties, setBurgerVarieties] = useState([]); // Variedades de hamburguesa
  const [selectedBurgerVarietyId, setSelectedBurgerVarietyId] = useState(
    editData.burger_id || null
  );
  const [selectedFriesAddonId, setSelectedFriesAddonId] = useState(
    editData.selectedFriesAddons?.[0] || null
  );

  // Efecto para obtener los datos de quesos, toppings y addons al cargar el componente
  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        setLoadingError(null);

        // Ejecutar todas las llamadas a la API en paralelo
        const [
          resCheeses,
          resToppings,
          resExtras,
          resItemsAddons,
          resBurgerVarieties,
        ] = await Promise.all([
          getData(
            `/api/get_cheeses_types_by_burguer_type/${type_id}/${branch_id}`
          ),
          getData(
            `/api/get_toppings_types_by_burguer_type/${type_id}/${branch_id}`
          ),
          getData(
            `/api/get_extras_types_by_burguer_type/${type_id}/${branch_id}`
          ),
          getData(
            `/api/get_items_addons_by_burguer_type/${type_id}/${branch_id}`
          ),
          getData(`/api/get_burger_varieties_by_type/${type_id}/${branch_id}`),
        ]);

        // Procesar respuestas y actualizar estados
        if (resCheeses.status === 200) {
          setCheeses(resCheeses.data.cheeses_by_burguer_type || []);
        } else {
          console.log("Error fetching cheese types");
        }

        if (resToppings.status === 200) {
          setToppings(resToppings.data.toppings_by_burguer_type || []);
        } else {
          console.log("Error fetching toppings types");
        }

        // Verificar si la hamburguesa tiene papas fritas disponibles
        if (
          resItemsAddons.status === 200 &&
          resItemsAddons.data.items_burguer_type?.length > 0
        ) {
          setFlagFries(resItemsAddons.data.items_burguer_type[0].side_fries || 0);
        } else {
          console.log("Error fetching items addons types");
          setFlagFries(0);
        }

        // Configurar los extras de papas fritas (si están disponibles)
        if (resExtras.status === 200 && resExtras.data.extras_by_burguer_type) {
          setFries(resExtras.data.extras_by_burguer_type || []);
        } else {
          console.log("Error fetching extras for fries");
          setFries([]);
        }

        if (resBurgerVarieties.status === 200) {
          setBurgerVarieties(resBurgerVarieties.data.burger_varieties || []);
        } else {
          console.log("Error fetching burger varieties");
          setBurgerVarieties([]);
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error);
        setLoadingError(
          "Error al cargar los datos. Por favor, inténtalo de nuevo."
        );
      } finally {
        setIsLoading(false);
      }
    };

    console.log("Fries", fries);

    fetchData();
  }, [type_id, size_id, branch_id]);
  useEffect(() => {
    if (burgerVarieties.length === 1) {
      setSelectedBurgerVarietyId(burgerVarieties[0].id);
    }
  }, [burgerVarieties]);

  // useEffect para cargar datos de edición
  useEffect(() => {
    if (isEditing && editData) {
      setSelectedCheeses(editData.selectedCheeses || []);
      setSelectedToppings(editData.selectedToppings || []);
      setSelectedFriesAddons(editData.selectedFriesAddons || []);
    }
  }, [isEditing, editData]);
  // Esta función maneja el cambio de selección de quesos
  const handleCheeseChange = (cheeseId) => {
    setSelectedCheeses((prevSelected) =>
      prevSelected.includes(cheeseId)
        ? prevSelected.filter((id) => id !== cheeseId)
        : [...prevSelected, cheeseId]
    );
  };
  // Esta función maneja el cambio de selección de toppings
  const handleToppingChange = (toppingId) => {
    setSelectedToppings((prevSelected) =>
      prevSelected.includes(toppingId)
        ? prevSelected.filter((id) => id !== toppingId)
        : [...prevSelected, toppingId]
    );
  };
  // Esta función maneja el cambio de cantidad de hamburguesas
  const handleQuantityChange = (e) => {
    const val = parseInt(e.target.value);
    if (!isNaN(val) && val > 0) {
      setQuantity(val);
    }
  };
  // Esta función maneja el cambio de selección de addons de papas fritas
  const handleFriesAddonChange = (addonId) => {
    setSelectedFriesAddons((prev) =>
      prev.includes(addonId)
        ? prev.filter((id) => id !== addonId)
        : [...prev, addonId]
    );
  };
  // Esta función maneja la finalización del pedido
  const handleFinishOrder = () => {
    if (!selectedBurgerVarietyId) {
      swalAlertInfo(
        "ATENCION",
        "Debes seleccionar una variedad de hamburguesa.",
        () => {}
      );
      return;
    }

    const burger = {
      burger_id: Number(selectedBurgerVarietyId),
      size_id: Number(size_id),
      type_id: Number(type_id),
      extraCheese,
      extra_cheese_price,
      base_price,
      sizeShortDesc,
      observation,
      cheeses: cheeses.filter((c) => selectedCheeses.includes(c.cheese_id)),
      toppings: toppings.filter((t) => selectedToppings.includes(t.topping_id)),
      // Usar addon_id para filtrar los extras de papas seleccionados
      fries_addons: selectedFriesAddonId
        ? fries.filter((a) => a.addon_id === selectedFriesAddonId)
        : [],
    };

    if (isEditing && editIndex !== undefined) {
      dispatch(editBurger(editIndex, burger, quantity));
    } else {
      dispatch(addBurger(burger, quantity));
    }
    navigate(`/cart/${branch_id}`);
  };
  // Esta función maneja la adición de una nueva hamburguesa al pedido
  const AddOrder = () => {
    if (!selectedBurgerVarietyId) {
      alert("Debes seleccionar una variedad de hamburguesa.");
      return;
    }
    const burger = {
      burger_id: Number(selectedBurgerVarietyId),
      size_id: Number(size_id),
      type_id: Number(type_id),
      extraCheese,
      extra_cheese_price,
      base_price,
      sizeShortDesc,
      observation,
      cheeses: cheeses.filter((c) => selectedCheeses.includes(c.cheese_id)),
      toppings: toppings.filter((t) => selectedToppings.includes(t.topping_id)),
      fries_addons: selectedFriesAddonId
        ? fries.filter((a) => a.addon_id === selectedFriesAddonId)
        : [],
    };

    if (isEditing && editIndex !== undefined) {
      dispatch(editBurger(editIndex, burger, quantity));
      navigate(`/cart/${branch_id}`);
    } else {
      dispatch(addBurger(burger, quantity));
      navigate(`/home/food_order/${branch_id}`);
    }
  };

  return (
    <>
      {isLoading ? (
        <div className="text-white position-relative bg-orange min-vh-100 d-flex align-items-center justify-content-center">
          <div className="text-center">
            <div className="spinner-border text-light mb-3" role="status">
              <span className="visually-hidden">Cargando...</span>
            </div>
            <h4>Cargando opciones...</h4>
            <p>Obteniendo quesos, toppings y extras disponibles</p>
          </div>
        </div>
      ) : loadingError ? (
        <div className="text-white position-relative bg-orange min-vh-100 d-flex align-items-center justify-content-center">
          <div className="text-center">
            <h4 className="text-danger mb-3">Error al cargar</h4>
            <p>{loadingError}</p>
            <button 
              className="btn btn-light"
              onClick={() => window.location.reload()}
            >
              Reintentar
            </button>
          </div>
        </div>
      ) : (
      <div className="text-white position-relative bg-orange">
        <div className="mb-5 py-2 ms-1">
          <BackButton />
        </div>
        <img src={Image} alt="Burger" className="d-flex mx-auto w-25 mb-5" />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-md-6 bg-dark brt-50">
              <div className="d-flex align-items-center ms-4 mt-1 mt-lg-4">
                <h1>{isEditing ? "Editar Billy" : "Arma tu Billy"}</h1>
                <h6 className="ms-2">(Talle {sizeShortDesc})</h6>
              </div>
              {burgerVarieties.length > 0 && (
                <div className="ms-4 mt-3">
                  <h5>Elegí la variedad:</h5>
                  <div className="d-flex flex-wrap gap-2 mt-3 mb-3">
                    {burgerVarieties.map((variety) => (
                      <button
                        key={variety.id}
                        className={`btn btn-sm ${
                          selectedBurgerVarietyId === variety.id
                            ? "btn-success"
                            : "btn-outline-light"
                        }`}
                        onClick={() => setSelectedBurgerVarietyId(variety.id)}
                        type="button"
                      >
                        {variety.burger_description}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              <h3 className="ms-3">¿Cuál queso preferís?</h3>
              <div className="row container">
                {Array.isArray(cheeses) && cheeses.length > 0 ? cheeses.map((cheese) => {
                  const checkboxId = `cheese-${cheese.cheese_id}`;
                  return (
                    <div key={cheese.cheese_id} className="col-6">
                      <label
                        className="checkbox-wrapper row align-items-center d-flex "
                        style={{ cursor: "pointer" }}
                        htmlFor={checkboxId}
                      >
                        <div className="col-1">
                          <input
                            type="checkbox"
                            id={checkboxId}
                            className="circle-check"
                            checked={selectedCheeses.includes(cheese.cheese_id)}
                            onChange={() => handleCheeseChange(cheese.cheese_id)}
                          />
                          <span className="circle-label"></span>
                        </div>
                        <div className="col-1">
                          <p className="mt-2 mb-0">
                            {cheese.cheese_description}
                          </p>
                        </div>
                      </label>
                    </div>
                  );
                }) : (
                  <div className="col-12 text-center py-3">
                    <p className="text-muted">No hay quesos disponibles</p>
                  </div>
                )}
              </div>
              <div className="mt-3 ms-3">
                <h5>¿Con extra queso?</h5>
                <div className="form-check">
                  <label
                    className="form-check-label d-flex align-items-center"
                    htmlFor="extraCheese"
                    style={{ cursor: "pointer" }}
                  >
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      id="extraCheese"
                      checked={extraCheese}
                      onChange={() => setExtraCheese((prev) => !prev)}
                    />
                    Sí (+${extra_cheese_price})
                  </label>
                </div>
              </div>

              <h3 className="mt-3 fw-bold ms-3 mb-4">Tus toppings y aderezos</h3>
              <div className="container row">
                {Array.isArray(toppings) && toppings.length > 0 ? toppings.map((topping) => {
                  const checkboxId = `topping-${topping.topping_id}`;
                  return (
                    <div
                      key={topping.topping_id}
                      className="col-6 mb-3 col-lg-4"
                    >
                      <label
                        htmlFor={checkboxId}
                        className="checkbox-wrapper d-flex align-items-center"
                        style={{ cursor: "pointer" }}
                      >
                        <input
                          type="checkbox"
                          id={checkboxId}
                          className="circle-check"
                          checked={selectedToppings.includes(
                            topping.topping_id
                          )} // Estado controlado
                          onChange={() =>
                            handleToppingChange(topping.topping_id)
                          } // Manejar cambio
                        />
                        <label
                          htmlFor={checkboxId}
                          className="circle-label me-2"
                        ></label>
                        <h6 className="mb-0 text-truncate" style={{ maxWidth: "150px" }}>
                          {topping.topping_name}
                        </h6>
                      </label>
                    </div>
                  );
                }) : (
                  <div className="col-12 text-center py-3">
                    <p className="text-white">No hay toppings disponibles para esta opción del menú</p>
                  </div>
                )}
              </div>
              {flagFries === 1 && (
                <>
                  <h3 className="mt-3 fw-bold ms-3">Papas Fritas</h3>
                  <div className="mb-2 ms-3">
                    <strong>¿Con qué acompañás tus papas?</strong>
                    {Array.isArray(fries) && fries.length > 0 ? fries.map((addon) => (
                        <div key={addon.addon_id} className="form-check mt-3">
                          <label
                            className="form-check-label d-flex align-items-center"
                            htmlFor={`fries-addon-${addon.addon_id}`}
                            style={{ cursor: "pointer" }}
                          >
                            <input
                              className="form-check-input me-2"
                              type="checkbox"
                              name="fries-addon"
                              id={`fries-addon-${addon.addon_id}`}
                              checked={selectedFriesAddonId === addon.addon_id}
                              onChange={() =>
                                setSelectedFriesAddonId(
                                  selectedFriesAddonId === addon.addon_id
                                    ? null
                                    : addon.addon_id
                                )
                              }
                            />
                            {addon.addon_name}{" "}
                            {Number(addon.extra_price) > 0 &&
                              `(+$${addon.extra_price})`}
                          </label>
                        </div>
                      )) : (
                        <div className="text-center py-2">
                          <p className="text-muted mb-0">No hay extras disponibles para papas</p>
                        </div>
                      )}
                  </div>
                </>
              )}
              <div className="d-flex align-items-center ms-3">
                <button
                  type="button"
                  className="btn-outline-secondary rounded-circle bg-beige border-0 d-flex justify-content-center align-items-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    fontSize: "1.5rem",
                    padding: 0,
                  }}
                  onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  aria-label="Restar cantidad"
                >
                  -
                </button>
                <input
                  id="quantity"
                  type="number"
                  min="1"
                  value={quantity}
                  onChange={handleQuantityChange}
                  className="input-type-number"
                />
                <button
                  type="button"
                  className="btn-outline-secondary rounded-circle bg-orange border-0 d-flex justify-content-center align-items-center"
                  style={{
                    width: "38px",
                    height: "38px",
                    fontSize: "1.5rem",
                    padding: 0,
                  }}
                  onClick={() => setQuantity((q) => q + 1)}
                  aria-label="Sumar cantidad"
                >
                  +
                </button>
              </div>
              {/* Campo observaciones */}
              <div className="mt-3 mb-5 ">
                <h3 className="text-center">Observaciones</h3>
                <hr />
                <div className="d-flex justify-content-center align-items-center">
                  <textarea
                    className="w-75 mx-auto text-center login-input"
                    rows="3"
                    maxLength={200}
                    placeholder="Si lo deseas, puedes especificar alguna observación para que se tenga en cuenta."
                    value={observation}
                    onChange={(e) => setObservations(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="d-flex justify-content-center my-4">
                <button className="btn btn-success" onClick={handleFinishOrder}>
                  {isEditing ? "Guardar Cambios" : "Terminar Pedido"}
                </button>
              </div>
              {!isEditing && (
                <div className="d-flex justify-content-center my-4">
                  <button
                    className="btn btn-success"
                    onClick={AddOrder}
                    type="submit"
                  >
                    Armar otra hamburguesa
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      )}
    </>
  );
};

export default OrderChooseToppings;
